import { DraggableResizablePanel } from "@minervaproject/fds";

import { InstructorNotes } from "./instructor_notes";

import { CenteredErrorBoundary } from "components/error_boundary";
import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { classroomSelectors, localSelectors } from "store";
import { setShowInstructorNotes } from "store/reducers/local";

const HEADER_HEIGHT = 48;
const SIDEBAR_WIDTH = 336;
const ELEMENT_BUFFER = 16;
const ELEMENT_WIDTH = 300;

function InstructorNotesWrapper() {
  const dispatch = useAppDispatch();
  const showInstructorNotes = useAppSelector(localSelectors.selectShowInstructorNotes());
  const activeTimelineSegment = useAppSelector(classroomSelectors.selectActiveTimelineSegment());
  const hasInstructorNotesOnActiveSegment =
    !!activeTimelineSegment &&
    ((activeTimelineSegment.notes?.faculty_instructions?.length || 0) > 0 ||
      (activeTimelineSegment.notes?.engagement_prompt?.length || 0) > 0 ||
      (activeTimelineSegment.notes?.focus_questions?.length || 0) > 0);

  if (!showInstructorNotes || !hasInstructorNotesOnActiveSegment) return null;

  return (
    <CenteredErrorBoundary text="Instructor Notes cannot be displayed">
      <DraggableResizablePanel
        initialX={window.innerWidth - (SIDEBAR_WIDTH + ELEMENT_BUFFER + ELEMENT_WIDTH)}
        initialY={HEADER_HEIGHT + ELEMENT_BUFFER}
        initialHeight={window.innerHeight - HEADER_HEIGHT - ELEMENT_BUFFER * 2}
        title="Instructor Notes"
        onClose={() => {
          dispatch(setShowInstructorNotes({ showInstructorNotes: false }));
        }}
        style={{ zIndex: 500, paddingBottom: "15px" }}
        cancel=":has(>.instructor-notes)"
      >
        <InstructorNotes notes={activeTimelineSegment.notes} />
      </DraggableResizablePanel>
    </CenteredErrorBoundary>
  );
}

export { InstructorNotesWrapper };
